export default __webpack_public_path__ + "images/0xe80772eaf6e2e18b651f160bc9158b2a5cafca65.png";